<template>
  <div class="form-group row">
    <label class="col-12">Caixa: <span class="text-danger">*</span></label>
    <div class="col-sm-12">
      <div class="form-group input-group" :class="{
        'form-group--error': $v.editarArquivamento.caixa.$error
      }">
        <input type="number" class="form-control" v-model="$v.editarArquivamento.caixa.$model">
      </div>
      <div class="error" v-if="!$v.editarArquivamento.caixa.required">O campo é obrigatório</div>
    </div>
    <div class="modal-body text-md-right text-sm-center">
      <button type="button" class="btn btn-outline-danger m-1" @click.prevent="() => {
          closeModalEvent()
        }">Cancelar</button>
      <button type="button" class="btn btn-outline-primary m-1" @click.prevent="() => {
                $refs.confirmacaoAlteracao.openModal()
              }">Editar</button>
    </div>
    <modal ref="confirmacaoAlteracao" width="500px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Deseja Realmente Trocar  o Número da Caixa para {{ $v.editarArquivamento.caixa.$model }} ?</h4>
          <i class="fa fa-times fa-1-5x m-2 link" @click="$refs.confirmacaoAlteracao.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.confirmacaoAlteracao.closeModal()">Cancelar</button>
          <button type="button" class="btn btn-outline-primary m-1" @click.prevent="editar()">Confirmar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VirtusService from '@/services/VirtusService'
import modal from '@/components/shared/Modal.vue'

export default {
  name: 'editararquivamento',

  components: {
    modal
  },

  props: {
    closeModalEvent: { required: true, type: Function },
    protocolo: { required: true, type: String },
    atualizarConsulta: { required: true, type: Function }
  },

  data () {
    return {
      editarArquivamento: {
        caixa: ''
      }
    }
  },

  validations: {
    editarArquivamento: {
      caixa: {
        required
      }
    }
  },

  created () {
    this.service = new VirtusService()
  },

  methods: {
    editar () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.service.editarArquivamento({
        ...this.editarArquivamento,
        numeroProcesso: this.protocolo
      }).then((data) => {
        this.closeModalEvent()
        this.atualizarConsulta()
      })
    }
  }
}
</script>
